import React, { Fragment, useEffect, useContext } from "react";
import YouTube from "../upload/YouTube";
import AcadUpload from "../upload/AcadUpload";
import "../../styles/fonts.css";
import "../../styles/index.css";
import UploadNonAcademic from "../upload/UploadNonAcademic";
import { appFirestore, timestamp } from "../../firebase/config";
import AuthContext from "../../context/auth/authContext";

const Choose = (props) => {
  const authContext = useContext(AuthContext);
  const { currentUser, addError } = authContext;
  const addToFirestore = async (info, collection) => {
    const collectionRef = appFirestore.collection(collection);
    const res = await collectionRef.add({
      ...info,
      date: timestamp(),
      owner: currentUser.uid,
    });
    return res.id;
  };

  const addToYoutube = async (info) => {
    const collectionRef = appFirestore.collection("youtube");
    let ytApiKey = "AIzaSyBBYO1Rpj71v_CiZW1nmPfsKqULdM32IUc";
    try {
      const res2 = await fetch(
        `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${info.url}&key=${ytApiKey}`
      );
      const jsss = await res2.json();
      info.name = jsss.items[0].snippet.title;
      info.author = jsss.items[0].snippet.channelTitle;
      let temp = jsss.items[0].snippet.tags || ["tag"];
      info.tags = [...temp, ...info.name.split(" "), ...info.author.split(" ")];
      const res = await collectionRef.add({
        ...info,
        date: timestamp(),
        suggestedBy: currentUser.displayName,
      });
      return res.id;
    } catch (error) {
      console.log(error);
      return "there was some error";
    }
  };
  useEffect(() => {
    if (!currentUser) {
      addError("Please login to upload resources");
      props.history.push("/");
    }
  }, []);
  return (
    <Fragment>
      <div className=''>
        <div className='w-75-condition mx-auto card'>
          <ul class='nav nav-tabs' id='myTab' role='tablist'>
            <li class='nav-item' role='presentation'>
              <a
                class='nav-link active fontcool nolinklook size10'
                id='home-tab'
                data-toggle='tab'
                href='#home'
                role='tab'
                aria-controls='home'
                aria-selected='true'
              >
                Academic Uploads
              </a>
            </li>
            <li class='nav-item' role='presentation'>
              <a
                class='nav-link fontcool nolinklook size10'
                id='profile-tab'
                data-toggle='tab'
                href='#profile'
                role='tab'
                aria-controls='profile'
                aria-selected='false'
              >
                Non Academic Uploads
              </a>
            </li>
            <li class='nav-item' role='presentation'>
              <a
                class='nav-link fontcool nolinklook size10'
                id='contact-tab'
                data-toggle='tab'
                href='#contact'
                role='tab'
                aria-controls='contact'
                aria-selected='false'
              >
                Youtube Uploads
              </a>
            </li>
          </ul>
          <div class='tab-content' id='myTabContent'>
            <div
              class='tab-pane fade show active'
              id='home'
              role='tabpanel'
              aria-labelledby='home-tab'
            >
              <AcadUpload
                history={props.history}
                addToFirestore={addToFirestore}
              />
            </div>
            <div
              class='tab-pane fade'
              id='profile'
              role='tabpanel'
              aria-labelledby='profile-tab'
            >
              <UploadNonAcademic
                history={props.history}
                addToFirestore={addToFirestore}
              />
            </div>
            <div
              class='tab-pane fade'
              id='contact'
              role='tabpanel'
              aria-labelledby='contact-tab'
            >
              <YouTube
                history={props.history}
                addError={addError}
                addToYoutube={addToYoutube}
              />
            </div>
          </div>
        </div>
      </div>
      <div class='jumbotron jumbotron-fluid mt-4 fontcool'>
        <div class='container'>
          <h1 class='display-4'>
            <u>How to upload for best search results:</u>
          </h1>
          <p class='lead'>
            <li>
              Fill every detail carefully as they will describe your material
            </li>
            <li>Enter every detail about your content in descripition</li>
            <li>Entered tags helps us to search precisely</li>
            <li>The file will then be send to the admin for approval</li>
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default Choose;
